import React from 'react'
import {Grid, Button} from '@material-ui/core'
import {buttonStyles} from '../styles/styles'
import {tabButtons} from '../defaults/templates'

const Tabs = ({settings, selectTab, tab}) => {
    const classes = buttonStyles()
    //console.log("Tab: tab: ", tab)
    let preview_button = tabButtons[4]
    return (
        <Grid container justifyContent="space-between" spacing={2}>
            <Grid item xs={9}>
                <Grid container justifyContent="flex-start" spacing={2}>
                    {tabButtons.map((b) => {
                        if(b.id < 5 && ! b.is_hidden){
                            let classArray = [classes.tab]
                            if(b === settings.tab)
                                classArray.push(classes.tab_selected)
                            let buttonClass = classArray.join(" ")
                            return (
                                <Grid key={b.id} item xs={3}>
                                    <Button name={b.name}
                                        className={buttonClass}
                                        disabled={b.is_disabled}
                                        onClick={() => selectTab(b.id)}>
                                        {b.title}
                                    </Button>
                                </Grid>
                            )
                        }else{
                            return null
                        }
                    })}
                    
                </Grid>
            </Grid>
            <Grid item xs={3} className={classes.tab_data_grid}>
                {(() => {
                    if (preview_button.is_hidden) {
                        return <></>
                    }
                    let classArray = [classes.tab_data]
                    if(preview_button === settings.tab)
                        classArray.push(classes.tab_selected)
                    let buttonClass = classArray.join(" ")
                    return (
                        <Button name={preview_button.name} className={buttonClass} onClick={() => selectTab(preview_button.id)}>
                            {preview_button.title}
                        </Button>
                    )
                })()}                
            </Grid>
        </Grid>
    )
}

export default Tabs;